export const MODULE_NAME = 'SERVICE_MONITORING';
